import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Lipsesc variabilele VITE_SUPABASE_URL și VITE_SUPABASE_ANON_KEY din .env'
  );
}

/**
 * Client Supabase — singleton, configurat pentru Capacitor mobile.
 * detectSessionInUrl: false → evită parsarea URL-ului pe fiecare load (overhead inutil pe native)
 * flowType: 'pkce'         → recomandat pentru OTP/magic-link pe mobile
 * persistSession: true      → sesiunea rămâne activă între reporniri
 */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});
